import { formatCurrency } from "helpers";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";

export const INVOICE_INCOMING_ITEMS_COLUMNS = (
  handleEditClick: (event: React.MouseEvent<HTMLSpanElement>, id: string) => void,
  handleDeleteClick: (event: React.MouseEvent<HTMLSpanElement>, id: string) => void
): Column[] => [
  {
    title: "Šifra",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => (
      <div className="text-md min-h-[40px] flex items-center font-light text-slate-500">{row.code}</div>
    ),
  },
  {
    title: "Naziv",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => <div className="text-md">{row.name}</div>,
  },
  {
    title: "PDV",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => <div className="text-md font-light text-slate-500">{row.taxRate} %</div>,
  },
  {
    title: "Količina",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => <div className="text-md font-light text-slate-500 tabular-nums">{row.quantity}</div>,
  },
  {
    title: "Cijena",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => (
      <div className="text-md font-light text-slate-500 tabular-nums">
        {formatCurrency.format(row.priceWithoutTax ?? 0)}
      </div>
    ),
  },
  {
    title: "Ukupno",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => (
      <div className="text-md font-medium tabular-nums">{formatCurrency.format(row.total ?? 0)}</div>
    ),
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => (
      <ButtonMenu
        endIcon="/media/icons/more-dots.svg"
        cssClassName="h-full"
        variant="text"
      >
        <ButtonMenuItem
          startIcon="/media/icons/edit.svg"
          onClick={(event: React.MouseEvent<HTMLSpanElement>) => handleEditClick(event, row.id)}
        >
          Ažuriraj
        </ButtonMenuItem>
        <ButtonMenuItem
          startIcon="/media/icons/trash.svg"
          variant="remove"
          onClick={(event: React.MouseEvent<HTMLSpanElement>) => handleDeleteClick(event, row.id)}
        >
          Obriši
        </ButtonMenuItem>
      </ButtonMenu>
    ),
  },
];
